<style src="css/articleList.css" scoped></style>
<template>
    <div style="padding-top: 1rem">
        <topbar text="全部文章" status="true"></topbar>
        <ul class="articleList" v-if="!emptyStatus">
            <li v-for="item in scaleUserFavoriteList" @click="to(`articleDetail?articleId=${item.articleId}`)">

                <div class="articleRight">
                    <div class="articleTitle">{{item.title}}</div>
                    <div class="articleContent">{{item.content}}</div>
                    <div class="nameBox">作者：{{item.author}} <div class="likeBox"><div class="eyeBox"></div>
                        {{item.readCount}} <div class="articlelike"></div>
                        {{item.loveCount}}</div></div>
                </div>
                <div class="itemLeftBox" :style="{background: `url(${EnvUrl}${item.pic}) no-repeat center/cover`}">
                </div>
            </li>
            <no-more-data :noMoreData="noMoreData"></no-more-data>
        </ul>

    </div>
</template>
<script>
    import {getSource, getSources} from "../api"

    import noMoreData from 'components/no-more-data'
    import topbar from 'components/topbar'
    import moment from 'moment/moment'

    import {Swiper, Slide} from 'vue-swiper-component';
    import {serialize} from 'utils/index'

    export default {
        data() {
            return {
//                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
                EnvUrl: `https://cdn.ysqingxin.com/`,
                slidesReal: [],
                scaleLabelList: [],
                scaleUserFavoriteList: [],
                indexNum: -1,
                labelId: '',
                pageIndex: 1,
                pageSize: 10,
                noMoreData: false,
                isLoading: false,
                emptyStatus: false,
                count: 0,
                testStatus: 0,
                userId: '',
            }
        },
        components: {
            noMoreData,
            topbar,
            Swiper,
            Slide,
        },
        filters: {
            time(value) {
                let transTime = moment(value).format('YYYY-MM-DD HH:mm:ss')
                return transTime
            },
        },
        computed: {},
        methods: {
            clickMe(n) {
                this.$router.push(`${n}`)
            },
            to(n) {
                this.$router.push(`/${n}`)
            },
            async getScaleBannerList() {
                let data = await getSources("/bear-scale/api/scaleHomePage/getScaleBannerList.json", {});
                if (data.status === 0) {
                    this.slidesReal = data.scaleBannerList
                }else{
                    alert(data.msg)
                }
            },
            handleScroll() {
//                console.log(11)
                let scrolltop = document.documentElement.scrollTop || document.body.scrollTop;
                let bottomOfWindow = document.documentElement.offsetHeight - scrolltop - window.innerHeight <= 200
                if (bottomOfWindow && this.isLoading == false) {

                    if (this.pageIndex >= Math.ceil(this.count / this.pageSize)) {
                        this.noMoreData = true
                    } else {
                        this.isLoading = true;
                        this.pageIndex = this.pageIndex + 1;
                        this.getScaleUserFavoriteList()
                    }
                }
            },
            async getScaleUserFavoriteList() {
                let obj = {}
                obj.pageIndex = this.pageIndex;
                obj.pageSize = this.pageSize;
                obj.companyId = localStorage.getItem('companyId')?localStorage.getItem('companyId'):'';
                let data = await getSources("/bear-scale/api/micro/getArticleList.json", obj);
                if (data.status === 0) {
                    this.isLoading = false;
                    this.count = data.count;
                    this.scaleUserFavoriteList = [...this.scaleUserFavoriteList, ...data.articleList];
                    if (data.articleList.length == 0) {
                        this.noMoreData = true
                    } else {
                        console.log(111111)
                        if (this.pageIndex >= Math.ceil(this.count / this.pageSize)) {
                            console.log('显示')
                            this.noMoreData = true
                        } else {
                            console.log(2)
                            this.noMoreData = false
                        }
                    }

                }else{
                    alert(data.msg)
                }
            },


            to(n) {
                this.$router.push(`/${n}`)
            },
        },
        destroyed(){
            window.removeEventListener('scroll', this.handleScroll);//监听页面滚动事件
        },
        mounted() {
            this.userId=localStorage.getItem('userId')
            this.getScaleUserFavoriteList();
            window.addEventListener('scroll', this.handleScroll);//监听页面滚动事件
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/articleList.vue?5cb636b5